import { useWindowWidth } from 'js/file_viewer/hooks/useWindowWidth';
export var FileViewerBreakpoint;
(function (FileViewerBreakpoint) {
    FileViewerBreakpoint["SM"] = "small";
    FileViewerBreakpoint["MD"] = "medium";
    FileViewerBreakpoint["LG"] = "large";
})(FileViewerBreakpoint || (FileViewerBreakpoint = {}));
export const useResponsiveSize = () => {
    const windowWidth = useWindowWidth();
    if (windowWidth === undefined || windowWidth > 1024) {
        return FileViewerBreakpoint.LG;
    }
    else if (windowWidth > 768) {
        return FileViewerBreakpoint.MD;
    }
    else {
        return FileViewerBreakpoint.SM;
    }
};
//# sourceMappingURL=responsive_size.preenvesnextjs.map
